import { render, staticRenderFns } from "./remove-qbank-from-cadidate-popup.html?vue&type=template&id=821e1412&scoped=true&external"
import script from "./remove-qbank-from-cadidate-popup.js?vue&type=script&lang=js&external"
export * from "./remove-qbank-from-cadidate-popup.js?vue&type=script&lang=js&external"
import style0 from "./remove-qbank-from-cadidate-popup.scss?vue&type=style&index=0&id=821e1412&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821e1412",
  null
  
)

export default component.exports